import { fetchConfig } from '@theme/utilities';
import { morphSection } from '@theme/section-renderer';

// Maison Veyra · Boton "+ Añadir" de "Completa tu look".
// Se carga en todas las paginas (ver snippets/glo-swatch-cart-fix.liquid) para que
// funcione aunque el bloque aparezca despues de abrir la pagina con el carrito vacio.

let StdEvents = null;
import('@shopify/events').then((m) => { StdEvents = m; }).catch(() => {});

if (!window.__mvCartUpsell) {
  window.__mvCartUpsell = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-mv-upsell-add]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    const card = btn.closest('.mv-upsell__card');
    if (!card) return;
    const msg = card.querySelector('.mv-upsell__msg');
    const say = (text) => { if (msg) msg.textContent = text; };

    let variants = [];
    try {
      variants = JSON.parse(card.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (e) {}
    const o1 = card.querySelector('[data-opt="1"]')?.value;
    const o2 = card.querySelector('[data-opt="2"]')?.value;
    const variant = variants.find(
      (v) => (o1 === undefined || v.o1 === o1) && (o2 === undefined || v.o2 === o2)
    );

    if (!variant) return say('Elige color y talla.');
    if (!variant.a) return say('Agotado en ese color y talla.');

    say('');
    btn.disabled = true;
    const label = btn.textContent;
    btn.textContent = 'Añadiendo…';

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')]
          .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
          .filter(Boolean)
      ),
    ];

    const formData = new FormData();
    formData.append('id', String(variant.id));
    formData.append('quantity', '1');
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    let added = false;
    try {
      const cfg = fetchConfig('javascript', { body: formData });
      const response = await fetch(Theme.routes.cart_add_url, {
        ...cfg,
        headers: { ...cfg.headers, Accept: 'text/html' },
      }).then((r) => r.json());

      if (response.status) throw new Error(response.description || response.message || 'Error');
      added = true;

      // Refrescar el carrito (lateral o pagina de carrito)
      const sections = response.sections || {};
      for (const id of Object.keys(sections)) {
        if (!sections[id]) continue;
        const inDrawer = id === 'cart-drawer-section' || !!document.querySelector(`theme-drawer [data-section-id="${id}"]`);
        morphSection(id, sections[id], { mode: inDrawer ? 'hydration' : 'full' });
      }

      // Actualizar el contador del icono del carrito
      try {
        const cart = await fetch(`${Theme.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then((r) => r.json());
        const ev = StdEvents?.CartLinesUpdateEvent;
        if (ev) {
          const deferred = ev.createPromise();
          document.dispatchEvent(
            new ev({
              action: 'add',
              context: 'cart',
              lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variant.id}`, quantity: 1 }],
              promise: deferred.promise,
            })
          );
          deferred.resolve({
            cart: ev.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'mv-cart-upsell', itemCount: cart.item_count, didError: false },
          });
        }
      } catch (e) {}
    } catch (error) {
      if (added) {
        window.location.reload();
        return;
      }
      btn.disabled = false;
      btn.textContent = label;
      say('No se pudo añadir. Inténtalo de nuevo.');
    }
  }, true);
}
